import React, { useState } from "react";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import useAxios from "@libs/axios/useAxios";
import { FILE_URL } from "@libs/apiUrl";

interface ProfileImageUploadProps {
  initialImage?: string;
  onImageChange?: (imageUrl: string) => void;
}

const ProfileImageUpload: React.FC<ProfileImageUploadProps> = ({
  initialImage,
  onImageChange,
}) => {
  const [image, setImage] = useState<string>(initialImage || "");
  const theme = useTheme();
  const { axiosInstance } = useAxios();

  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      setImage(URL.createObjectURL(file)); // 미리보기용

      const formData = new FormData();
      formData.append("files", file, file.name);

      try {
        const res = await axiosInstance.post(FILE_URL, formData);
        // 부모에게 새로운 이미지 URL 전달
        onImageChange?.(res.data.data[0].url);
      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    }
  };

  const displayImage = image || initialImage;

  return (
    <Container>
      <ImageWrapper>
        {displayImage ? (
          <ProfileImage src={displayImage} alt="Profile" />
        ) : (
          <DefaultImage>
            <Image
              src={theme.image.profile_icon}
              alt="Profile"
              width="100%"
              height="100%"
            />
          </DefaultImage>
        )}

        <UploadIcon htmlFor="file-upload">
          <Image
            src={theme.image.camera_icon}
            width="2.6rem "
            height="2.6rem"
          />
        </UploadIcon>
      </ImageWrapper>

      <Input
        type="file"
        id="file-upload"
        onChange={handleImageChange}
        accept="image/*"
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 10rem;
  height: 10rem;
`;

const UploadIcon = styled.label`
  position: absolute;
  bottom: 0;
  right: 0;
  cursor: pointer;
`;

const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

const DefaultImage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Input = styled.input({
  display: "none",
});

export default ProfileImageUpload;
